import React from "react";
import "../../../_css/Reporting.css";
import CustomChart from "./CustomChart";

const TotalPracticesChart = ({ practices }) => {
  return (
    <div className="box-con">
      <div className="admin-header di-flex">
        <div className="heading-subtext">Total practices per month</div>
        {/* <DropDown options={["This month", "This week", "This year"]} data={performancePeriod} setData={setPerformancePeriod}/> */}
      </div>

      {practices && (
        <div
          className="admin-content"
          style={{ width: "100%", height: "300px", backgroundColor: "white" }}
        >
          <CustomChart
            type="bar"
            xData={[...Object.keys(practices)]}
            yData={[...Object.values(practices)]}
            label="Practices"
            color="#10B981"
            tension={0}
            ygrid={true}
            yTicks={false}
            isMaxValue={true}
            barGap={0.6}
            perfixbar=""
            showValuesOnBar={true}
          />
        </div>
      )}
    </div>
  );
};

export default TotalPracticesChart;
